import React from 'react';

export const TITLE = [
  {
    textSize: '6rem',
    textType: 'h1',
    marginBottom: '3.25rem',
    textMobile: '2.2rem',
    renderContent: () => <span>WHO WE ARE</span>,
  },
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>
        At KUTER, we turn ideas into visuals that make an impact.
        <br />
        With over 20 years of experience, we craft stories where art direction,
        visual narrative, and top-tier execution come together.
        <br />
        <br />
        We believe a strong concept deserves an exceptional build.
        <br />
        <br />
        That’s why we develop every project at the root: we pitch, design, and
        direct with strategic focus, creative control, and a sharp aesthetic.
        <br />
        <br />
        In-house talent and full audiovisual production allow us to deliver work
        with a modern, agile, cinematic edge.
        <br />
        <br />
        Imagine.
        <br />
        Make it real.
        <br />
        <br />
        That’s KUTER. One idea can change everything.
      </span>
    ),
  },
];
